<template lang="html">
  <v-app class="large-screen__body white">
    <topbar class='fixed-nav'></topbar>
    <div class="fixed-top">
      <v-toolbar tabs>
      <v-btn icon @click ="goBack()">
        <i class="back-icon"></i>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text pb-4">
        {{ getUserName() }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <i class="more-icon"></i>
      </v-btn>
      </v-toolbar>
    </div>
    <div class="body white fixed-body chat-body" @scroll="onChatScroll" ref="chats">
      <!-- <div class="chat-heading">Today</div> -->
      <span v-if="fetchingChats" class="chat-loader-holder pt-4"><loader class="half-circle-spinner-chat"></loader></span>
      <div class="list-container">
        <template v-for="item in messages">
          <div v-if="item.recipient_user_id === userId" :key="item.msg_id" :id="item.msg_id">
            <div>
              <div class="chat-other-user">
                <div class="chat-head">
                  <img v-if="getAvatar(item.sender_user_id)" :src="getAvatar(item.sender_user_id)">
                  <span v-else class="avatar-txt  white--text">{{ getUserNameInitials(item.sender_user_id) }}</span>
                  <div class="pl-2">{{ item.value | unescape }}</div>
                </div>
              </div>
              <span class="date-text pt-1">{{ getTime(item.time_f)  }}</span>
            </div>
          </div>
          <div v-else :key="item.msg_id" :id="item.msg_id">
            <div class="user-chat mb-3">
              <div class="user-message">{{ item.value | unescape }}</div>
              <div class="date-text pt-1">{{ getTime(item.time_f) }}</div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="input-container-chat px-3" id="bottom-fixed">
      <v-text-field
        single-line
        type="text"
        placeholder="Type here..."
        v-model="message"
        @keyup.enter = "addChatMessage(message)"
      >
      </v-text-field>
    </div>
  </v-app>
</template>

<script>
import { getPrivateChatsViaSocket, addPrivateChatMessageViaSocket } from '@/api';
import Topbar from '@/components/Topbar';
import Loader from '@/components/Loader';
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import moment from 'moment';

export default {
  components: {
    Topbar,
    Loader,
  },
  data() {
    return {
      message: null,
      fetchingChats: false,
      isNewMessage: false,
      messages: [],
      contributors: [],
      timeRange: {},
      initialLoad: true,
      newDate: false,
      channelCode: null,
    };
  },
  computed: {
    recepientId() {
      return this.$route.params.id;
    },
    userId() {
      return this.$store.getters['auth/userId'];
    },
  },
  methods: {
    getTime(item) {
      const time = moment(item).format('MMM D, hh:mm a');
      return time;
    },
    getUserName() {
      for (let i = 0; i < this.contributors.length; i += 1) {
        if (this.contributors[i].user_id === this.recepientId) {
          return this.contributors[i].username;
        }
      }
      return 'No Name';
    },
    getUserNameInitials(userId) {
      for (let i = 0; i < this.contributors.length; i += 1) {
        if (this.contributors[i].user_id === userId) {
          return this.contributors[i].username.substring(0, 2).toUpperCase();
        }
      }
      return 'NN';
    },
    getAvatar(userId) {
      let avatar = null;
      for (let i = 0; i < this.contributors.length; i += 1) {
        if (this.contributors[i].user_id === userId) {
          avatar = this.contributors[i].avatar;
        }
      }
      return avatar;
    },
    goBack() {
      this.$router.go(-1);
    },
    scrollBottom() {
      const chatBox = this.$refs.chats;
      chatBox.scrollTop = chatBox.scrollHeight;
    },
    onChatScroll(e) {
      const offsetTop = e.target.scrollTop;
      this.isNewMessage = false;
      if (offsetTop === 0) {
        const id = document.getElementById(get(this.messages, '[0].msg_id'));
        this.fetchChats();
        if (id && this.timeRange.max_time !== '0' && this.timeRange.min_time !== '0') {
          id.scrollIntoView();
        }
      }
      if (offsetTop < 20) {
        this.showScrollUp = false;
      } else {
        this.showScrollUp = true;
      }
    },
    addChatMessage(message) {
      if (!message || message.trim().length === 0) return;
      const userToken = this.$store.getters['auth/userToken'];
      const convoUserId = this.$route.params.id;
      const values = {
        convo_user_id: convoUserId,
        msg: message,
      };
      this.message = null;
      this.isNewMessage = true;
      addPrivateChatMessageViaSocket(userToken, values, this.handleChatsResponse);
    },
    handleChatsResponse(response) {
      const data = JSON.parse(response.data);

      const messageChannel = get(data, '[1].data.details.convo_info.convo_id');
      this.channelCode = this.channelCode || messageChannel;

      if (this.channelCode !== messageChannel) {
        return;
      }

      const timeRange = get(data, '[1].data.details.timerange', {});
      this.timeRange = timeRange;
      this.fetchingChats = false;

      let contributors = get(data, '[1].data.details.contributors.details', []);
      contributors = [...contributors, ...this.contributors];
      this.contributors = uniqBy(contributors, 'user_id');

      // in time range min or max is 0 then no need to update other items
      if (this.timeRange.min_time === '0' || this.timeRange.max_time === '0') return;
      // extract the message, merge it, only keep uniq ones
      let messages = get(data, '[1].data.details.messages', []);
      messages = [...messages, ...this.messages];
      messages = uniqBy(messages, 'msg_id');
      this.messages = this.sortByDate(messages, 'time_f');

      // extract contributors, merge them, keep unique
      this.$nextTick(() => {
        if (this.isNewMessage || this.initialLoad) {
          this.scrollBottom();
          this.initialLoad = false;
        }
      });
    },
    fetchChats() {
      const userToken = this.$store.getters['auth/userToken'];
      const convoUserId = this.$route.params.id;
      const minTime = this.timeRange.min_time;
      // when start from becomes 0, no more fetching will be required.
      if (minTime === '0') return;
      this.fetchingChats = true;
      const values = {
        convo_user_id: convoUserId,
        before_time: minTime,
      };

      getPrivateChatsViaSocket(userToken, values, this.handleChatsResponse);
    },
    sortByDate(messageArray, dateKey) {
      return messageArray.sort((a, b) => (a[dateKey] > b[dateKey] ? 1 : -1));
    },
  },
  mounted() {
    this.fetchChats();
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

#app {

  #bottom-fixed {
    z-index: 40;
  }

  .chat-loader-holder {
    align-self: center;
  }
  .half-circle-spinner-chat {
    width: 30px;
    height: 30px;
    margin:0px;
  }

  .list-container {
    display: flex;
    flex-direction: column;
    margin-top: auto;
  }

  .chat-body {
    // css to make the chat start from bottom
    display: flex;
    flex-direction: column;
    height: auto;
    // flex-flow: column-reverse;
  }

  .chat-body::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }

  .chat-body::-webkit-scrollbar {
    width: 6px;
    background-color: #F5F5F5;
  }

  .chat-body::-webkit-scrollbar-thumb {
    background-color: #b2bac2;
  }

  @media only screen and (max-width: 599px) {
    .fixed-nav {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }

    .fixed-top {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 33;
    }

    .fixed-body {
      position: fixed;
      top: 95px;
      right: 0;
      left: 0;
      bottom: 65px;
      overflow-y: scroll;
      z-index: 35;
    }
  }

  @media only screen and (min-width: 600px) and (max-width: 1600px) {
    // fix the top navbar as well
    .fixed-nav {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 1;
    }

    .fixed-top {
      position: fixed;
      top: 50px;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 33;
    }

    .fixed-body {
      position: fixed;
      top: 150px;
      right: 0;
      left: 0;
      bottom: 65px;
      overflow-y: scroll;
      z-index: 35;
    }
  }


  @media only screen and (min-width: 1600px) {
    .fixed-top {
      z-index: 20;
      position: fixed;
      left: 300px;
      width: calc(100vw - 300px);
    }

    .fixed-body {
      z-index: 40;
      position: fixed;
      top: 90px;
      right: 0;
      bottom: 50px;
      left: 300px;
      overflow-y: scroll;
      width: calc(100vw - 320px);
    }
  }

  .toolbar__title {
    text-align: center;
    white-space: initial;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 10px;
    padding-right: 10px;
    margin-left: 0px;
    margin-top: 22px;
  }
  .chat-heading {
    text-align:center;
    font-size: 13px;
    color: black;
  }

  .body {
    padding-left: 29px;
    padding-right: 29px;
    padding-bottom: 10px;
  }

  .user-chat {
    margin-left: auto;
    width: fit-content;
    max-width: 69%;
    .user-message {
      color: white;
      border-radius: 12px;
      text-align: right;
      font-size:14px;
      padding:14px;
      background-color: $blue;
    }
    .date-text {
      text-align: right;
    }
  }

  .date-text {
    color: $header;
    font-size: 11px;
    padding-top: 2px;
  }

  .chat-other-user {
    width: fit-content;
    max-width: 80%;
    text-align: left;
    margin-top: 16px;
    padding: 10px;
    background-color: $filter-background;
    border-radius: 12px;
  }

  .chat-head {
    align-items: center;
    border-radius: 50%;
    display: inline-flex;
    justify-content: center;
    text-align: center;
    vertical-align: middle;
    display: flex;
    justify-content: flex-start;
    span {
      font-size: 14px;
      border-radius:50%;
      height: 32px;
      width: 32px;
      padding-left: 5px;
      margin-left: -21px;
      background: $blue;
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    img {
      border-radius:50%;
      height: 32px;
      width: inherit;
      padding-right: 4px;
      margin-left: -21px;
    }
  }
  .input-container-chat {
    position: fixed;
    bottom: 10px;
    border-color: $border-color;
    border-radius: 8px;
    padding:14px;
    background-color: #fbfbfb;
    box-shadow: 0 2px 6px 0 rgba(224, 153, 153, 0.5);
  }

  .input-container-chat input:focus, .input-container textarea:focus {
    outline: none;
    width: 100%;
  }

  @media only screen and (max-width: 411px) {
    .input-container-chat {
      width: 91%;
      margin-left: 18px;
    }
    .btn-toggle {
      width:55%;
      .btn {
        border: 1px solid white;
      }
    }
  }

  @media only screen and (max-width:499px) and (min-width: 412px) {
    .input-container-chat {
      width: 91%;
      margin-left: 16px;
    }
  }

  @media only screen and (max-width:600px) and (min-width: 500px) {
    .input-container-chat {
      width: 94%;
      margin-left: 16px;
    }
  }

  @media only screen and (max-width:712px) and (min-width: 601px) {
    .input-container-chat {
      width: 94%;
      margin-left: 18px;
    }
  }

  @media only screen and (max-width:800px) and (min-width: 713px) {
    .input-container-chat {
      width: 96%;
      margin-left: 16px;
    }
  }

  @media only screen and (max-width:1024px) and (min-width: 801px) {
    .input-container-chat {
      width: 96%;
      margin-left: 16px;
    }
    .btn-toggle {
      width:20%;
      .btn {
        border: 1px solid white;
      }
    }
  }

  @media only screen and (max-width:1300px) and (min-width: 1025px) {
    .input-container-chat {
      width: 97%;
      margin-left: 16px;
    }
  }

  @media only screen and (max-width:1600px) and (min-width: 1301px) {
    .input-container-chat {
      width: 97%;
      margin-left: 20px;
    }
  }

  @media only screen and (max-width:1860px) and (min-width: 1601px) {
    .input-container-chat {
      width: 80%;
      margin-left: 19px;
    }
  }

  @media only screen and (max-width:1893px) and (min-width: 1861px) {
    .input-container-chat {
      width: 82%;
      margin-left: 19px;
    }
  }

  @media only screen and (max-width:2100px) and (min-width: 1894px) {
    .input-container-chat {
      width: 83%;
      margin-left: 19px;
    }
  }

  @media only screen and (max-width:2350px) and (min-width: 2101px) {
    .input-container-chat {
      width: 85%;
      margin-left: 17px;
    }
  }

  @media only screen and (max-width:2520px) and (min-width: 2351px) {
    .input-container-chat {
      width: 86%;
      margin-left: 14px;
    }
  }

  @media only screen and (max-width:2800px) and (min-width: 2521px) {
    .input-container-chat {
      width: 86%;
      margin-left: 22px;
    }
  }

  @media only screen and (max-width:3700px) and (min-width: 2801px) {
    .input-container-chat {
      width: 88%;
      margin-left: 17px;
    }
  }

  @media only screen and (max-width:5600px) and (min-width: 3701px) {
    .input-container-chat {
      width: 91%;
      margin-left: 17px;
    }
  }

  @media only screen and (max-width:7500px) and (min-width: 5601px) {
    .input-container-chat {
      width: 94%;
      margin-left: 17px;
    }
  }

  @media only screen and (min-width:7501px) {
    .input-container-chat {
      width: 95%;
      margin-left: 35px;
    }
  }

  @media only screen and (max-width: 800px) {
    .toolbar {
      margin-bottom: -2px;
    }
  }
  // @media only screen and (max-width: 800px) {
  //   .btn {
  //     padding:6px;
  //   }
  //   .toolbar {
  //     padding-bottom:20px;
  //     margin-bottom: -2px;
  //   }
  // }
}
</style>



// WEBPACK FOOTER //
// src/components/MessagePrivateChat.vue